let expandGallery = document.querySelector('.expand-gallery');
let allImages = document.querySelectorAll('.product-main-slide');
let shown = document.querySelectorAll('.product-main-slide[data-variant-image-show]');
if (shown.length < 1) {
  shown = document.querySelectorAll('.product-main-slide');
}
let origHeightForDesktop = shown[0].clientHeight;
let newHeightForDesktop = shown[0].clientHeight / 2 * (Math.ceil(shown.length / 2) + 2) + 5;
if (shown.length > 1) {
  origHeightForDesktop = shown[1].clientHeight * 3;
  newHeightForDesktop = shown[1].clientHeight * (Math.ceil(shown.length / 2) + 2) + 5;
}
let slideshowEl = document.querySelector('.product-slideshow');
if (window.innerWidth > 768) {
    slideshowEl.style.maxHeight = `${origHeightForDesktop}px`;
}
if (shown.length < 4 && expandGallery) {
    expandGallery.style.display = "none";
}
shown.forEach((sld, index) => {
    sld.setAttribute('data-grid-index', `${index + 1}`);
})
expandGallery?.addEventListener('click', function(e) {
    e.preventDefault();
    if (slideshowEl.classList.contains('gallery-expanded')) {
        slideshowEl.classList.remove('gallery-expanded');
        // Check screen size
        if (window.innerWidth > 768) {
            slideshowEl.style.maxHeight = `${origHeightForDesktop}px`;
        }
        else {
            slideshowEl.style.maxHeight = '300vw';
        }
        expandGallery.querySelector('span').innerHTML = "Show more";
    }
    else {
        // Check screen size
        if (window.innerWidth > 768) {
            slideshowEl.style.maxHeight = `calc(${newHeightForDesktop}px)`;
        }
        else {
            slideshowEl.style.maxHeight = `calc(${shown.length * 100}vw + ${shown.length - 1}px)`;
        }
        slideshowEl.classList.add('gallery-expanded');
        expandGallery.querySelector('span').innerHTML = "Show less";
    }
})

document.addEventListener('variant:change', function (evt) {
  let newVariant = evt.detail.variant;
  // Option combination with no matching variant: keep the current images
  if (!newVariant) return;
  
  allImages.forEach(slide => {
    slide.removeAttribute('data-variant-image-show');
    slide.removeAttribute('data-grid-index');
    if (slide.hasAttribute(`data-variant-${ newVariant.id }`)) {
      slide.setAttribute('data-variant-image-show', '');
    }
  })
  shown = document.querySelectorAll('.product-main-slide[data-variant-image-show]');
  shown.forEach((slide, index) => {
    slide.setAttribute('data-grid-index', `${index + 1}`);
  });

  origHeightForDesktop = shown[1].clientHeight * 3 || shown[0].clientHeight * 1.5;
  newHeightForDesktop = shown[1].clientHeight * (Math.ceil(shown.length / 2) + 2) || shown[0].clientHeight;
    // Show/hide expand button
  if (shown.length < 4) {
    expandGallery.classList.add('hide');
  } else {
    expandGallery.classList.remove('hide');
    if (slideshowEl.classList.contains('gallery-expanded')) {
      if (window.innerWidth > 768) {
          slideshowEl.style.maxHeight = `calc(${newHeightForDesktop}px)`;
      }
      else {
          slideshowEl.style.maxHeight = `calc(${shown.length * 100}vw + ${shown.length - 1}px)`;
      }
    }
  }

});